import styled from 'styled-components';



export const StdIconsLeft = styled.div`

grid-area: 2 / 2 / 3 / 6;
display: flex;

`;

export const BTIcon = styled.button`

border: 0px;
padding: 0px;
margin: 0px;
background: none;
cursor: pointer;
position: relative;
display: flex;
-webkit-box-align: center;
align-items: center;
width: auto;
height: 24px;
text-align: left;
font-size: 0px;
//color: rgb(255, 255, 255); //color texto menu
color: rgb(0, 30, 80); //color texto menu


&:hover, &:focus {
    color: rgb(0, 176, 240);
    outline: 0px;
    svg{
        fill: rgb(0, 176, 240);
    }
   
}
&:focus::before{
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% + 16px);
    height: calc(100% + 16px);
    border: 2px solid rgb(0, 176, 240);
    transform: translate3d(-50%, -50%, 0px);
    transition: width 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
}
&::after{
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: max(100%, 44px);
    min-height: max(100%, 44px);
    transform: translate(-50%, -50%);
}




`;
export const StdIcon = styled.div`
color: rgb(0, 30, 80);
fill: rgb(0, 30, 80);
    svg{
        fill:inherit;
    }
`;
export const TextMenu = styled.div`

    display: inline-block;
    box-sizing: border-box;
    padding-top: 1px;
    padding-left: 10px;
    max-width: calc(25vw);
    overflow: hidden;
    span{
        color: inherit;
    margin: unset;
    font-family: var(--font-family-text);
    font-weight: bold;
    font-size: 0.88rem;
    line-height: 150%;
    letter-spacing: calc(-0.02em + 0.02rem);
}

    

`




